/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: cbfced083eca
 */

import { uploadPresetsCreateUploadPreset } from "../../funcs/uploadPresetsCreateUploadPreset.js";
import { UploadPresetInput$zodSchema } from "../../models/uploadpresetinput.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: UploadPresetInput$zodSchema.describe(
    `The upload preset configuration.`,
  ),
};

export const tool$uploadPresetsCreateUploadPreset: ToolDefinition<typeof args> =
  {
    name: "create-upload-preset",
    description:
      `Creates a new upload preset with specified configuration settings`,
    scopes: ["builder"],
    annotations: {
      "title": "Create Upload Preset",
      "destructiveHint": false,
      "idempotentHint": false,
      "openWorldHint": false,
      "readOnlyHint": false,
    },
    args,
    tool: async (client, args, ctx) => {
      const [result] = await uploadPresetsCreateUploadPreset(
        client,
        args.request,
        { fetchOptions: { signal: ctx.signal } },
      ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      return formatResult(result.value);
    },
  };
